
window.addEventListener('DOMContentLoaded', function () {
  let animated = document.querySelector('.container-sticky-add-to-cart');
  if(animated) {
    
    let sticky = document.querySelector('.sticky-add-to-cart');

    
    
    function showSticky() {
          //variable box message button page
      let launcher = document.querySelector('#launcher');
      let messageCompany = document.querySelectorAll('iframe')[4];
      let closeMessage = document.querySelectorAll('iframe')[5];
      let moreInfo = document.querySelector('button.needsclick.kl-teaser-URxdDb.undefined.kl-private-reset-css-Xuajs1')
     
      let scrollTop = document.documentElement.scrollTop;
      let height = animated.offsetTop;
      if (height - 100 < scrollTop ) {
        sticky.classList.add('active');
      } else {
        sticky.classList.remove('active'); 
        
      }
    }
    window.addEventListener('scroll', showSticky);
  }
  
  

});
